(function () {
  function initCard(card) {
    if (card.dataset.sliderInit === 'true') return;
    card.dataset.sliderInit = 'true';

    const shell = card.querySelector('.ps-card__media-shell');
    const mediaLink = card.querySelector('.ps-card__mediaLink');
    const track = card.querySelector('[data-card-track]');
    const items = Array.from(card.querySelectorAll('.card__media-item'));
    const prev = card.querySelector('[data-card-prev]');
    const next = card.querySelector('[data-card-next]');
    const progress = card.querySelector('[data-card-progress]');

    if (!track || items.length <= 1) return;

    let index = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let isSwiping = false;

    function updateTrack() {
      track.style.transform = `translateX(-${index * 100}%)`;
    }

    function updateButtons() {
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= items.length - 1;
    }

    function updateProgress() {
      if (!progress) return;
      const step = 100 / items.length;
      progress.style.width = `${step}%`;
      progress.style.transform = `translateX(${index * 100}%)`;
    }

    function updateUI() {
      updateTrack();
      updateButtons();
      updateProgress();
    }

    function goTo(newIndex) {
      index = Math.max(0, Math.min(newIndex, items.length - 1));
      updateUI();
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(index + 1);
      });
    }

    if (shell) {
      shell.addEventListener('touchstart', function (e) {
        const t = e.changedTouches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
        touchEndX = t.clientX;
        isSwiping = false;
      }, { passive: true });

      shell.addEventListener('touchmove', function (e) {
        const t = e.changedTouches[0];
        touchEndX = t.clientX;

        const dx = Math.abs(t.clientX - touchStartX);
        const dy = Math.abs(t.clientY - touchStartY);

        if (dx > 12 && dx > dy) {
          isSwiping = true;
        }
      }, { passive: true });

      shell.addEventListener('touchend', function () {
        const delta = touchEndX - touchStartX;

        if (!isSwiping || Math.abs(delta) < 30) {
          isSwiping = false;
          return;
        }

        if (delta < 0) {
          goTo(index + 1);
        } else {
          goTo(index - 1);
        }

        setTimeout(() => {
          isSwiping = false;
        }, 50);
      }, { passive: true });
    }

    if (mediaLink) {
      mediaLink.addEventListener('click', function (e) {
        if (isSwiping) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    card.addEventListener('mouseleave', function () {
      if (window.innerWidth >= 750) {
        goTo(0);
      }
    });

    updateUI();
  }

  function boot(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-card-media-slider]').forEach(initCard);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    boot(event.target);
  });
})();